export enum PortfolioBaseType {
  PORTFOLIO_CHART = 'Portfolio Chart',
  STATISTICS_AND_POSITIONS = 'Statistics and Positions',
  MANAGER_ROSTER_ALLOCATION = 'Manager Roster',
  HOLDINGS = 'Holdings',
}
